export default "__VITE_ASSET__49d91431__"